import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { of } from 'rxjs';
import { TopnavInfoService } from '../menuInterfaces/topnav-info.service';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent {
  navbarOpen = false;

  routeData$ = this.route.data;
  userRole$ = this.infoService.getUserRoles();

  constructor(private route: ActivatedRoute, private infoService: TopnavInfoService) {}

  toggleNavbar = () => {
    this.navbarOpen = !this.navbarOpen;
  };

  rolesOk = (roles: string[]) => {
    if (!roles) {
      return of(true);
    }

    return this.userRole$.pipe(map(userRoles => roles.some(role => userRoles.indexOf(role) >= 0)));
  };
}
